







































































import moment from 'moment';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import config from '@/config/index';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { actionsEvent } from '@/setup';
import { Accion } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { Funcionalidades } from '@/config/funcionalidades';
import { AgGridUtil } from '@/agGridUtil/agGridUtil';
import Confirmation from '@/components/Confirmation.vue';
import HandleErrors from '@/config/handleErrors';
import store from '@/store';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import {
  checkboxColumnDef,
  makeAccionesColumnDef,
} from '@/reusable/Grid/aggridColumnDefUtils';
const { AgGridVue } = require('ag-grid-vue');

import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { LoadingService } from '@/services/loadingService';
import { fetchOrdenesCompra } from './fetchOrdenesCompra';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import Dispositivo from '../Dispositivos/Dispositivo.vue';
import { forEach } from 'lodash';

@Component({
  components: {
    AgGridVue,
    Confirmation,
    MantenedorGridSinCodigo,
  },
})
export default class modalAutorizadores extends Vue {
  @Prop() compranumero: any;
  @Prop({ default: false }) showAutorizadores: boolean;
  @Prop({ default: false }) edicion: boolean;
  accionesTotales: PermisoAccion[] = [];
  $snotify: any;
  filtro: string = '';
  ordesList: any[] = [];

  funcionalidad: Funcionalidades =
    Funcionalidades.TablaAutorizadoresOrdenCompra;
  usuario = JSON.parse(localStorage.getItem('user')).id;

  cerrarModal() {
    this.$emit('cerrarAutorizadores', true);
  }
  confirmationConfirm: boolean = false;
  confirmationEdit: boolean = false;
  userSelected: any;
  usersName: String = '';
  showConfirmation() {
    this.userSelected = this.gridApi.getSelectedRows();
    if (this.userSelected.length < 1) {
      this.$snotify.error('Por favor seleccione minimo 1 autorizadores ', {
        timeout: 3000,
      });
      return;
    }
    this.usersName = this.userSelected.map((e: any) => ` ${e.nombre}`);
    this.confirmationConfirm = true;
  }
  arrayEdit: any = [];
  arrayNew: any = [];
  totalNames: any = [];
  showConfirmationEdit() {
    this.totalNames = [];
    this.userSelected = [];
    this.userSelected = this.gridApi.getSelectedRows();
    if (this.userSelected.length < 1) {
      this.$snotify.error('Por favor seleccione minimo 1 autorizador', {
        timeout: 3000,
      });
      return;
    }
    this.userSelected.forEach((e: any) => {
      if (!this.arraySelected.includes(e.usuarioid)) {
        this.arrayNew.push(e);
      } else if (this.arraySelected.includes(e.usuarioid)) {
        let index = this.arraySelected.indexOf(e.usuarioid);
        this.arraySelected.splice(index, 1);
      }
      this.totalNames.push(e.nombre);
    });
    this.confirmationEdit = true;
  }

  closeConfirmation(data: boolean) {
    this.confirmationConfirm = false;
    if (data) {
      this.guardar();
      this.confirmationConfirm = false;
    }
  }

  closeConfirmationEdit(data: boolean) {
    this.confirmationEdit = false;
    if (data) {
      this.editar();
      this.confirmationConfirm = false;
    }
  }

  editar() {
    let usersFinal = {
      new: this.arrayNew,
      removed: this.arraySelected,
      names: this.totalNames,
    };
    this.$emit('confirmAutorizadoresEdit', usersFinal);
  }

  guardar() {
    this.$emit('autorizadoresConfirmados', this.userSelected);
  }

  mounted() {}
  Sims: any;
  selected: any = [];
  arraySelected: any = [];
  async loadInformation() {
    this.loadingService.showLoading();
    this.ordesList = await this.getAutorizadores();
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
    this.loadingService.hideLoading();
  }
  async reloadData(numero: number) {
    this.gridApi.setRowData([]);
    this.ordesList = await this.getAutorizadores(numero);
    this.arrayNew = [];
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }
  async loadSelected(numero: number) {
    this.arraySelected = [];
    this.loadingService.showLoading();
    await this.reloadData(numero);
    this.selected = await this.getAutorizadoresSelected(numero);
    this.arraySelected = this.selected.map((e: any) => e.usuarioid);
    this.gridApi.forEachNode(node => {
      node.setSelected(this.arraySelected.includes(node.data.usuarioid));
    });
    this.loadingService.hideLoading();
  }

  async getAutorizadoresSelected(numero: number) {
    let self = this;
    this.loadingService.showLoading();
    return fetchOrdenesCompra(
      { numero: numero },
      'conectaOrdenesCompra/get_autorizadores_selected'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error(
          'Ocurrió un error al cargar los autorizadores seleccionados, por favor reintente',
          { timeout: 3000 }
        );
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async getAutorizadores(numero: any = '') {
    let self = this;
    this.loadingService.showLoading();
    return fetchOrdenesCompra(
      { compranumero: numero },
      'conectaOrdenesCompra/get_autorizadores'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error(
          'Ocurrió un error al cargar los autorizadores, por favor reintente',
          { timeout: 3000 }
        );
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async handleGridReady(event: GridReadyEvent) {
    this.ordesList = await this.getAutorizadores();
    this.gridApi = event.api;
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }

  async updateData(numero: number) {
    this.gridApi.setRowData([]);
    this.ordesList = await this.getAutorizadores();
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
    this.loadSelected(numero);
  }

  changeNoSelected() {
    this.gridApi.forEachNode(node => {
      node.setSelected(false);
    });
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  selectedRows: any = [];

  onSelectionChanged(params: any) {
    this.selectedRows = this.gridApi.getSelectedRows();
  }

  // Globales

  dialog: Boolean = false;
  search: string = '';
  localeText: any = config.agGridTextos;
  gridOptions: GridOptions;

  loadingService = new LoadingService();

  editedIndex: number = -1;

  handleErrors: HandleErrors = new HandleErrors();

  // Controller
  readonly controller: string = 'funcionalidad';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  // Grilla
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  agGridUtil: AgGridUtil;
  serverSide: any;

  // Interfaces
  editedItem: IFuncionalidad = {};
  funcionalidades: Array<IFuncionalidad> = [];

  //vuex
  usuarioId: number = store.state.userId;

  dateFormatter(params: any) {
    return moment(params.value).format('MM/DD/YYYY');
  }

  constructor() {
    super();
    this.columnDefs = [
      {
        headerName: 'Usuario',
        field: 'nombre',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        sortable: true,
        width: 300,
      },
      {
        headerName: 'Correo',
        field: 'email',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        sortable: true,
        width: 600,
      },
      {
        headerName: 'Estado',
        field: 'estado',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        sortable: true,
        width: 300,
      },
      {
        headerName: 'Solicitar',
        width: 100,
        checkboxSelection: true,
      },
    ];

    this.gridOptions = {
      pagination: true,
      paginationPageSize: 6, //Solución Paginación
      //cacheBlockSize: 50, //Solución Paginación
      //paginationAutoPageSize: false,
      rowModelType: 'normal',
      columnDefs: this.columnDefs,
      //rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
      rowSelection: 'multiple',
      columnTypes: {
        fecha: {
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
      onGridReady: this.handleGridReady,
      onModelUpdated: this.onModelUpdated,
      onSelectionChanged: this.onSelectionChanged,
      processCellForClipboard: ({ value }) => {
        return value instanceof moment
          ? this.formatFecha(value as moment.Moment)
          : value;
      },
      onGridSizeChanged: event => {
        event.api.sizeColumnsToFit();
      },
    };
  }

  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }
}
